import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var productCustomData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_config, data, globalConfig) {
    var result, pluginOutputs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(!globalConfig.custom && !globalConfig.plugins)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", null);
        case 2:
          result = {};
          if (globalConfig.custom) {
            Object.entries(globalConfig.custom).forEach(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                key = _ref3[0],
                value = _ref3[1];
              result["".concat(globalConfig.product, ":").concat(key)] = value;
            });
          }
          if (!globalConfig.plugins) {
            _context.next = 9;
            break;
          }
          _context.next = 7;
          return Promise.all(globalConfig.plugins.map(function (plugin) {
            return plugin({
              start: data.start,
              stop: data.stop,
              key: data.key
            });
          }));
        case 7:
          pluginOutputs = _context.sent;
          pluginOutputs.forEach(function (pluginOutput) {
            if (pluginOutput === null) {
              return;
            }
            Object.entries(pluginOutput).forEach(function (_ref4) {
              var _ref5 = _slicedToArray(_ref4, 2),
                key = _ref5[0],
                value = _ref5[1];
              result["".concat(globalConfig.product, ":").concat(key)] = value;
            });
          });
        case 9:
          return _context.abrupt("return", result);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function productCustomData(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();